'use client'

import { SpaceProps } from '../../themes'
import { BaseTruncate } from './styles'

export interface TruncateProps extends SpaceProps {
  /**
   * Number of lines to show
   */
  lines?: number

  /**
   * HTML title attribute
   */
  title?: string

  /**
   * Children
   */
  children?: React.ReactNode
}

export const Truncate = ({
  lines = 1,
  title,
  children,
  ...spaceProps
}: TruncateProps) => {
  return (
    <BaseTruncate lines={lines} title={title} {...spaceProps}>
      {children}
    </BaseTruncate>
  )
}
